import { Link } from "react-router";
import { useAuth } from "../hooks/useAuth";

export default function Nav() {
  const { user, isAuthenticated, logout } = useAuth();

  return (
    <nav className="mb-8 w-1/2 flex justify-between items-center  ">
      <Link to="/" className="text-2xl text-blue-500 hover:underline">
        Home
      </Link>
      {/* <Link to="/notes" className="text-2xl text-blue-500 hover:underline">
        Notes
      </Link> */}
      {isAuthenticated ? (
        <div className="flex items-center">
          <span className="mr-4">Welcome, {user?.username}!</span>
          <button
            onClick={logout}
            className="bg-red-500 text-white rounded px-4 py-2"
          >
            Logout
          </button>
        </div>
      ) : (
        <Link to="/login" className="text-2xl text-blue-500 hover:underline">
          Login
        </Link>
      )}
    </nav>
  );
}
